import moment from 'moment';

export default function datetime(str) {
   const date = moment.utc(str).toDate();
   return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}
